import { Text, TextDescription, TextTitle } from "../components/Texts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import DateFormatter from "../modules/utils/DateFormatter";
import DatePicker from "../components/DatePicker";
import React from "react";
import Section from "../components/Section";
import Table from "../components/Table";
import _find from "lodash/find";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import _values from "lodash/values";
import colors from "../styles/colors";
import { compose } from "redux";
import moment from "moment";

import performanceAction from "../modules/performance/actions";
import performanceSelectors from "../modules/performance/selectors";

import facebookActions from "../modules/facebook/actions";
import facebookSeletors from "../modules/facebook/selectors";

import mainActions from "../modules/main/actions";
import mainSelectors from "../modules/main/selectors";

import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";
import withUserPerm from "services/withUserPerm";
import TopBar from "../components/TopBar";

import Loading from "components/Loading";

const Performance = () => {
  //eslint-disable-next-line no-unused-vars
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [t] = useTranslation();
  const dispatch = useDispatch();
  let history = useHistory();

  const [loadedSelfServiceSettings, setLoadedSelfServiceSettings] = useState(false);

  const currentAd = useSelector((state) => mainSelectors.currentFacebookAd(state));
  const fbReportList = useSelector((state) => performanceSelectors.fbreportList(state));
  const [selectedViewValue, setSelectedViewValue] = useState();
  const [yesterdayAsDefault, setYesterdayAsDefault] = useState(true);
  const [loading, setLoading] = useState(true);
  const [performanceDataState, setPerformanceDataState] = useState([]);
  const getFacebookSettingsResult = useSelector((state) => facebookSeletors.getFacebookSettingsResult(state));

  useEffect(() => {
    if (!currentAd.ads_account_id) {
      getFacebookSettings();
    }
  }, []);

  useEffect(() => {
    if (loadedSelfServiceSettings === true) {
      checkAdsAccountConnection();
    }
  }, [currentAd, loadedSelfServiceSettings]);

  const getFacebookSettings = async () => {
    const facebookSettings = await dispatch(
      facebookActions.getFacebookSettings({
        token: rmpToken,
      }),
    );

    if (facebookSettings.result === 0 && facebookSettings.data[0] && facebookSettings.data[0].fb_ads_account_id) {
      dispatch(
        mainActions.SetFacebookAd({
          account_name: facebookSettings.data[0].fb_ads_account_name,
          ads_account_id: facebookSettings.data[0].fb_ads_account_id,
          type: "fb",
          currency_code: "THB",
          create_time: null,
          update_time: null,
        }),
      );

      setLoadedSelfServiceSettings(true);
    } else if (facebookSettings.result === 0 && facebookSettings.data.length === 0) {
      history.push("/no-connected-ads");
    }
  };

  const checkAdsAccountConnection = () => {
    if (!currentAd || currentAd === "" || !currentAd.ads_account_id) {
      history.push("/no-connected-ads");
    }
  };

  const getPerformance = async () => {
    try {
      setLoading(true);
      await dispatch(
        performanceAction.GetFBReportList({
          ads_account_id: currentAd.ads_account_id,
          date_preset: selectedViewValue.key,
        }),
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("inUseEffectInPerformanceFacebook", selectedViewValue);
    if (selectedViewValue && currentAd.ads_account_id) {
      getPerformance();
    }
  }, [selectedViewValue, currentAd.ads_account_id, dispatch]);

  useEffect(() => {
    let performanceData = fbReportList || {};
    setPerformanceDataState(performanceData);
  }, [fbReportList]);

  let selectedView = { title: "R-CRM", value: "R-CRM" };

  if (!yesterdayAsDefault && selectedViewValue && selectedViewValue.key === "today" && performanceDataState) {
    setYesterdayAsDefault(true);
    setLoading(false);
  }

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={t("__account_performance")} />
        </StyledContainerTopBar>
        <DatePicker
          key={moment.locale() + " " + yesterdayAsDefault}
          onSelected={setSelectedViewValue}
          defaultIndex={yesterdayAsDefault ? 1 : 0}
        />
      </StyledContainerTop>
      {loading === true ? (
        <Loading />
      ) : (
        <>
          <AllMetrics dataList={performanceDataState} view={selectedView} />
        </>
      )}
    </div>
  );
};

export default compose(withUserPerm())(Performance);

const AllMetrics = ({ dataList, view }) => {
  //eslint-disable-next-line no-unused-vars
  const isMobile = useWindowSize().width < 768;
  const [t] = useTranslation();
  const [selectedSortOption, setSelectedSortOption] = useState({ key: "date", direction: "desc" });
  let formatDate = DateFormatter.formatDateFull;

  if (view.value === "monthly") {
    formatDate = DateFormatter.formatMonthYear;
  }

  const tableColumns = [
    {
      key: "campaign_name",
      title: t("__campaign"),
      options: {
        width: "160px",
        strongText: true,
        fontSize: "10px",
      },
    },
    {
      key: "spend",
      title: t("__cost"),
      options: {
        align: "right",
      },
    },
    {
      key: "clicks",
      title: t("__clicks"),
      options: {
        align: "right",
      },
    },
    {
      key: "impressions",
      title: t("__impressions"),
      options: {
        align: "right",
      },
    },
    {
      key: "ctr",
      title: t("__ctr"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "cpc",
      title: t("__cpc"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "conversions",
      title: t("__conversion"),
      options: {
        align: "right",
      },
    },
  ];

  const sortOptions = {
    ...selectedSortOption,
    onSelected: setSelectedSortOption,
  };

  return (
    <Section margin="0 0 24px">
      <Table columns={tableColumns} data={dataList} responsiveColumns={2} maxHeight="280px" sortOptions={sortOptions} />
    </Section>
  );
};

const EmptyContent = () => {
  const [t] = useTranslation();
  return (
    <StyledEmptyContainer>
      <p>{t("__no_data")}</p>
    </StyledEmptyContainer>
  );
};

const StyledEmptyContainer = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
